<ng-container *transloco="let t">
	<eventlyte-registration-stepper-progress
		[currentStep]="AppRoutePaths.RegistrationQuestions"
		[steps]="getSteps()"
		[maxStepReached]="maxStepReached" />

	<p class="title is-4 pb-1 mb-1">{{ t('content.steps.questions') }}</p>

	<div class="content">
		<p>{{ t('content.pages.matching.instructions') }}</p>
	</div>

	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovYourIndustrySector"
			[formGroup]="formGroup"
			[label]="t('fields.bgovYourIndustrySector.label')"
				[value]="getRecordValue(record, 'bgovYourIndustrySector')"
			(valueChange)="setRecordValue(record, 'bgovYourIndustrySector', $event)"
			[editing]="true"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="Tech, Software & Internet Services"
				[label]="t('fields.bgovYourIndustrySector.options.Tech, Software & Internet Services')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Banking, Finance & Insurance"
				[label]="t('fields.bgovYourIndustrySector.options.Banking, Finance & Insurance')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Manufacturing, Electronics & Industrial"
				[label]="t('fields.bgovYourIndustrySector.options.Manufacturing, Electronics & Industrial')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Retail, E-commerce & Hospitality"
				[label]="t('fields.bgovYourIndustrySector.options.Retail, E-commerce & Hospitality')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Real Estate, Construction & Facility Management"
				[label]="t('fields.bgovYourIndustrySector.options.Real Estate, Construction & Facility Management')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Healthcare, Biotech & Wellness"
				[label]="t('fields.bgovYourIndustrySector.options.Healthcare, Biotech & Wellness')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Education, Training & HR"
				[label]="t('fields.bgovYourIndustrySector.options.Education, Training & HR')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Marketing, Media & Creative Industries"
				[label]="t('fields.bgovYourIndustrySector.options.Marketing, Media & Creative Industries')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Logistics, Transportation & Trade"
				[label]="t('fields.bgovYourIndustrySector.options.Logistics, Transportation & Trade')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Government, NGO & Industry Association"
				[label]="t('fields.bgovYourIndustrySector.options.Government, NGO & Industry Association')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Other"
				[label]="t('fields.bgovYourIndustrySector.options.Other')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>
	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovCompanySize"
			[formGroup]="formGroup"
			[label]="t('fields.bgovCompanySize.label')"
				[value]="getRecordValue(record, 'bgovCompanySize')"
			(valueChange)="setRecordValue(record, 'bgovCompanySize', $event)"
			[editing]="true"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="1-50 Employees"
				[label]="t('fields.bgovCompanySize.options.1-50 Employees')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="51-100 Employees"
				[label]="t('fields.bgovCompanySize.options.51-100 Employees')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="101-500 Employees"
				[label]="t('fields.bgovCompanySize.options.101-500 Employees')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="501 or above Employees"
				[label]="t('fields.bgovCompanySize.options.501 or above Employees')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>
	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovJobRole"
			[formGroup]="formGroup"
			[label]="t('fields.bgovJobRole.label')"
				[value]="getRecordValue(record, 'bgovJobRole')"
			(valueChange)="setRecordValue(record, 'bgovJobRole', $event)"
			[editing]="true"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="Senior Management / Decision Maker / Founder"
				[label]="t('fields.bgovJobRole.options.Senior Management / Decision Maker / Founder')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Investor"
				[label]="t('fields.bgovJobRole.options.Investor')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Technical Professional (Engineer / Developer)"
				[label]="t('fields.bgovJobRole.options.Technical Professional (Engineer / Developer)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Operations / Project Management"
				[label]="t('fields.bgovJobRole.options.Operations / Project Management')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Sales & Marketing"
				[label]="t('fields.bgovJobRole.options.Sales & Marketing')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Consultant / Industry Advisor"
				[label]="t('fields.bgovJobRole.options.Consultant / Industry Advisor')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Academic / Researcher / Data Analyst"
				[label]="t('fields.bgovJobRole.options.Academic / Researcher / Data Analyst')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Media / Influencer"
				[label]="t('fields.bgovJobRole.options.Media / Influencer')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Student"
				[label]="t('fields.bgovJobRole.options.Student')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Other"
				[label]="t('fields.bgovJobRole.options.Other')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>
	<div class="mb-5">
		<eventlyte-tag-list-field
			formKey="bgovTechnologiesAndSolutionInterests"
			[formGroup]="formGroup"
			[label]="t('fields.bgovTechnologiesAndSolutionInterests.label')"
				[value]="getRecordValue(record, 'bgovTechnologiesAndSolutionInterests')"
			(valueChange)="setRecordValue(record, 'bgovTechnologiesAndSolutionInterests', $event)"
			[editing]="true"
			[multipleSelection]="true"
			[maximumSelectable]="3"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="AI & Machine Learning"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.AI & Machine Learning')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Generative AI / Large Language Models (LLM)"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Generative AI / Large Language Models (LLM)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Data Analytics / Big Data / Business Intelligence"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Data Analytics / Big Data / Business Intelligence')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Computer Vision"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Computer Vision')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Internet of Things (IoT)"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Internet of Things (IoT)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Robotics & Intelligent Automation"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Robotics & Intelligent Automation')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Cloud Computing / Cloud Services"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Cloud Computing / Cloud Services')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Edge Computing"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Edge Computing')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Cybersecurity"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Cybersecurity')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI Infrastructure & Data Platforms"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.AI Infrastructure & Data Platforms')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="DevOps / AI Development Tools"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.DevOps / AI Development Tools')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Blockchain"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Blockchain')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Marketing Technology (MarTech)"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Marketing Technology (MarTech)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Metaverse / Virtual Worlds"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Metaverse / Virtual Worlds')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="Other"
				[label]="t('fields.bgovTechnologiesAndSolutionInterests.options.Other')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>
	<div class="mb-5 single-column-question">
		<eventlyte-tag-list-field
			formKey="bgovInterestedInNetworkEvents"
			[formGroup]="formGroup"
			[label]="t('fields.bgovInterestedInNetworkEvents.label')"
				[value]="getRecordValue(record, 'bgovInterestedInNetworkEvents')"
			(valueChange)="setRecordValue(record, 'bgovInterestedInNetworkEvents', $event)"
			[editing]="true"
			[multipleSelection]="true"
			[maximumSelectable]="10000"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="AI+ Skills Lab (Workshop)"
				[label]="t('fields.bgovInterestedInNetworkEvents.options.AI+ Skills Lab (Workshop)')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="2026. 6. 4 (Thursday) - 16:00 - 18:00 BUSINESS Networking Happy Hour"
				[label]="t('fields.bgovInterestedInNetworkEvents.options.2026. 6. 4 (Thursday) - 16:00 - 18:00 BUSINESS Networking Happy Hour')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="2026. 6. 5 (Friday) - 16:00 - 18:00 BUSINESS Networking Happy Hour"
				[label]="t('fields.bgovInterestedInNetworkEvents.options.2026. 6. 5 (Friday) - 16:00 - 18:00 BUSINESS Networking Happy Hour')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="AI+ Power Awards by BGOV - Prize Presentation Ceremony"
				[label]="t('fields.bgovInterestedInNetworkEvents.options.AI+ Power Awards by BGOV - Prize Presentation Ceremony')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="I do not have a plan to join"
				[label]="t('fields.bgovInterestedInNetworkEvents.options.I do not have a plan to join')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>

	@if (false) {
		<div class="mb-5 single-column-question">
			<eventlyte-tag-list-field
				formKey="bgovInterestedToConference"
				[formGroup]="formGroup"
				[label]="t('fields.bgovInterestedToConference.label')"
					[value]="getRecordValue(record, 'bgovInterestedToConference')"
				(valueChange)="setRecordValue(record, 'bgovInterestedToConference', $event)"
				[editing]="true"
				[multipleSelection]="true"
				[maximumSelectable]="10000"
				[deselectable]="false"
			>
				<eventlyte-tag-field
					value="AI+ Power 2026 Keynote Presentations"
					[label]="t('fields.bgovInterestedToConference.options.AI+ Power 2026 Keynote Presentations')"
					[hasExtraText]="false"
					[background]="ViewColor.Light"
				/>
				<eventlyte-tag-field
					value="AI+ FinTech & Digital Finance"
					[label]="t('fields.bgovInterestedToConference.options.AI+ FinTech & Digital Finance')"
					[hasExtraText]="false"
					[background]="ViewColor.Light"
				/>
				<eventlyte-tag-field
					value="AI+ Marketing, Digital Media & Growth"
					[label]="t('fields.bgovInterestedToConference.options.AI+ Marketing, Digital Media & Growth')"
					[hasExtraText]="false"
					[background]="ViewColor.Light"
				/>
				<eventlyte-tag-field
					value="AI Security, Governance & Ethics"
					[label]="t('fields.bgovInterestedToConference.options.AI Security, Governance & Ethics')"
					[hasExtraText]="false"
					[background]="ViewColor.Light"
				/>
				<eventlyte-tag-field
					value="AI+ Workplace & Enterprise Productivity"
					[label]="t('fields.bgovInterestedToConference.options.AI+ Workplace & Enterprise Productivity')"
					[hasExtraText]="false"
					[background]="ViewColor.Light"
				/>
				<eventlyte-tag-field
					value="AI+ Sales, Customer Success & Revenue Engines"
					[label]="t('fields.bgovInterestedToConference.options.AI+ Sales, Customer Success & Revenue Engines')"
					[hasExtraText]="false"
					[background]="ViewColor.Light"
				/>
				<eventlyte-tag-field
					value="AI+ adoption across industries"
					[label]="t('fields.bgovInterestedToConference.options.AI+ adoption across industries')"
					[hasExtraText]="false"
					[background]="ViewColor.Light"
				/>
			</eventlyte-tag-list-field>

		</div>
	}

	<div class="mb-5">
		<label class="label is-normal mb-3">{{
			t('fields.bgovInterestedToConference.label')
		}}</label>
		<div class="columns is-multiline is-variable is-4">
			<div class="column is-12-tablet is-4-desktop">
				<div class="box p-4" style="height: 100%; border: 1px solid #dbdbdb">
					<p class="title is-6 mb-3">
						{{ t('content.bgovInterestedToConference.days.4June') }}
					</p>
					<eventlyte-tag-list-field
						formKey="bgovInterestedToConference"
						[formGroup]="formGroup"
						[value]="getRecordValue(record, 'bgovInterestedToConference')"
						(valueChange)="setRecordValue(record, 'bgovInterestedToConference', $event)"
						[editing]="true"
						[multipleSelection]="true"
						[maximumSelectable]="10000">
						<eventlyte-tag-field
							value="AI+ Power 2026 Keynote Presentations"
							[label]="
								t(
									'fields.bgovInterestedToConference.options.AI+ Power 2026 Keynote Presentations'
								)
							"
							[hasExtraText]="false"
							[background]="ViewColor.Light" />
						<eventlyte-tag-field
							value="AI+ FinTech & Digital Finance"
							[label]="
								t(
									'fields.bgovInterestedToConference.options.AI+ FinTech & Digital Finance'
								)
							"
							[hasExtraText]="false"
							[background]="ViewColor.Light" />
					</eventlyte-tag-list-field>
				</div>
			</div>
			<div class="column is-12-tablet is-4-desktop">
				<div class="box p-4" style="height: 100%; border: 1px solid #dbdbdb">
					<p class="title is-6 mb-3">
						{{ t('content.bgovInterestedToConference.days.5June') }}
					</p>
					<eventlyte-tag-list-field
						formKey="bgovInterestedToConference"
						[formGroup]="formGroup"
						[value]="getRecordValue(record, 'bgovInterestedToConference')"
						(valueChange)="setRecordValue(record, 'bgovInterestedToConference', $event)"
						[editing]="true"
						[multipleSelection]="true"
						[maximumSelectable]="10000">
						<eventlyte-tag-field
							value="AI+ Marketing, Digital Media & Growth"
							[label]="
								t(
									'fields.bgovInterestedToConference.options.AI+ Marketing, Digital Media & Growth'
								)
							"
							[hasExtraText]="false"
							[background]="ViewColor.Light" />
						<eventlyte-tag-field
							value="AI Security, Governance & Ethics"
							[label]="
								t(
									'fields.bgovInterestedToConference.options.AI Security, Governance & Ethics'
								)
							"
							[hasExtraText]="false"
							[background]="ViewColor.Light" />
						<eventlyte-tag-field
							value="AI+ adoption across industries"
							[label]="
								t(
									'fields.bgovInterestedToConference.options.AI+ adoption across industries'
								)
							"
							[hasExtraText]="false"
							[background]="ViewColor.Light" />
					</eventlyte-tag-list-field>
				</div>
			</div>
			<div class="column is-12-tablet is-4-desktop">
				<div class="box p-4" style="height: 100%; border: 1px solid #dbdbdb">
					<p class="title is-6 mb-3">
						{{ t('content.bgovInterestedToConference.days.4-5June') }}
					</p>
					<eventlyte-tag-list-field
						formKey="bgovInterestedToConference"
						[formGroup]="formGroup"
						[value]="getRecordValue(record, 'bgovInterestedToConference')"
						(valueChange)="setRecordValue(record, 'bgovInterestedToConference', $event)"
						[editing]="true"
						[multipleSelection]="true"
						[maximumSelectable]="10000">
						<eventlyte-tag-field
							value="AI+ Workplace & Enterprise Productivity"
							[label]="
								t(
									'fields.bgovInterestedToConference.options.AI+ Workplace & Enterprise Productivity'
								)
							"
							[hasExtraText]="false"
							[background]="ViewColor.Light" />
						<eventlyte-tag-field
							value="AI+ Sales, Customer Success & Revenue Engines"
							[label]="
								t(
									'fields.bgovInterestedToConference.options.AI+ Sales, Customer Success & Revenue Engines'
								)
							"
							[hasExtraText]="false"
							[background]="ViewColor.Light" />
					</eventlyte-tag-list-field>
				</div>
			</div>
		</div>
	</div>
	<div class="mb-5 single-column-question">
		<eventlyte-tag-list-field
			formKey="bgovBmInterestedInBusinessMatching"
			[formGroup]="formGroup"
			[label]="t('fields.bgovBmInterestedInBusinessMatching.label')"
				[value]="getRecordValue(record, 'bgovBmInterestedInBusinessMatching')"
			(valueChange)="setRecordValue(record, 'bgovBmInterestedInBusinessMatching', $event)"
			[editing]="true"
			[deselectable]="false"
		>
			<eventlyte-tag-field
				value="Interested"
				[label]="t('fields.bgovBmInterestedInBusinessMatching.options.Interested')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
			<eventlyte-tag-field
				value="No"
				[label]="t('fields.bgovBmInterestedInBusinessMatching.options.No')"
				[hasExtraText]="false"
				[background]="ViewColor.Light"
			/>
		</eventlyte-tag-list-field>

	</div>

	<eventlyte-registration-stepper-controls
		[currentStep]="AppRoutePaths.RegistrationQuestions"
		[steps]="getSteps()"
		(startAgain)="startAgain()"
		(submitClick)="continue()"
		[processing]="saving()" />

	@if (showFormErrors()) {
		<eventlyte-registration-form-errors-modal
			[(active)]="showFormErrors"
			[formGroups]="validationFormGroups!" />
	}

	@if (showServerErrors()) {
		<eventlyte-registration-server-errors-modal
			[(active)]="showServerErrors"
			[errorList]="serverErrorList()" />
	}
</ng-container>
